import React, { useContext } from 'react'

import { SelectOptionsField, TemplateData } from '../../../../types/blueprint'

import { ListModal, Column } from '@/components/form-components/ListModal'
import { EditorContext } from '@/context/templateEditorContext'

const COLUMNS: Column[] = [
  {
    name: 'label',
    label: 'Label',
    inputType: 'text',
    defaultValue: '',
  },
]

type Props = {
  value: SelectOptionsField[]
  onChange: (value: SelectOptionsField[]) => void
}

export const SelectInput: React.FC<Props> = ({ value, onChange }) => {
  const editorState = useContext(EditorContext)

  const getExistingSelectInputs = (
    template: TemplateData
  ): SelectOptionsField[][] => {
    if (!template) return []

    const existingSelects = []

    template.sections.forEach((section) => {
      section?.blockGroups.forEach((blockGroup) => {
        blockGroup?.blocks.forEach((block) => {
          if (block?.type === 'select' && block?.options?.length > 0) {
            existingSelects.push(
              block?.options?.map((o) => ({
                label: o.label,
              }))
            )
          }
        })
      })
    })

    return existingSelects
  }

  return (
    <ListModal
      columns={COLUMNS}
      value={value}
      onChange={onChange}
      buttonText="Edit items"
      modalTitle="Configure Select items"
      existing={{
        textField: COLUMNS[0].name,
        values: getExistingSelectInputs(editorState.template),
      }}
      dataTestId="dropdown-edit-items-button"
    />
  )
}
